import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import {} from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './aidas-object.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AidasObjectDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const aidasObjectEntity = useAppSelector(state => state.aidasObject.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="aidasObjectDetailsHeading">AidasObject</h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">ID</span>
          </dt>
          <dd>{aidasObjectEntity.id}</dd>
          <dt>
            <span id="name">Name</span>
          </dt>
          <dd>{aidasObjectEntity.name}</dd>
          <dt>
            <span id="description">Description</span>
          </dt>
          <dd>{aidasObjectEntity.description}</dd>
          <dt>
            <span id="numberOfUploadReqd">Number Of Upload Reqd</span>
          </dt>
          <dd>{aidasObjectEntity.numberOfUploadReqd}</dd>
          <dt>Aidas Project</dt>
          <dd>{aidasObjectEntity.aidasProject ? aidasObjectEntity.aidasProject.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/aidas-object" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/aidas-object/${aidasObjectEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

export default AidasObjectDetail;
